import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { of } from 'rxjs/internal/observable/of';

@Injectable({
  providedIn: 'root'
})
export class ReportsTurnsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public filterTurnsList(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIdList, statusList, turnDeskInternalIdList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { datetimeFrom, datetimeTo, centerInternalIdList, statusList, turnDeskInternalIdList };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_filterTurnList', item, options);
  }

  public turnsDetailsList(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { datetimeFrom, datetimeTo, centerInternalIds };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/statistics/turns/details', options);
  }

  public listTurnsPerType(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { datetimeFrom, datetimeTo, centerInternalIds };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/statistics/turnsAtHour/media', options);
  }

  public listTurnsPerDesk(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { datetimeFrom, datetimeTo, centerInternalIds };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/statistics/turnsAtHour/deskName', options);
  }

  public bestDesks(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { datetimeFrom, datetimeTo, centerInternalIds };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/statistics/turns/moreActiveDesks', options);
  }

  public waitingTimePerDesk(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { datetimeFrom, datetimeTo, centerInternalIds};
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/statistics/minutesAtHour/waiting', options);
  }

  public attentionTimePerDesk(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { datetimeFrom, datetimeTo, centerInternalIds};
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/statistics/minutesAtHour/attending', options);
  }

}
